import styled from 'styled-components';

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  background: #f5f5f5;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #2b2b2b;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e8e8e8;
    border-color: #9a9a9a;
  }
`;

export const PanelExportHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0 10px 0;
  flex-shrink: 0;
`;
